module.exports = __webpack_public_path__ + "media/images/chat/missing_image-0297f1229ac3a8bf3fffcf5499fcab14.png";